function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M187.733,315.733c0,4.71,3.823,8.533,8.533,8.533H230.4c4.71,0,8.533-3.823,8.533-8.533v-51.2 c0-4.71-3.823-8.533-8.533-8.533h-34.133c-4.71,0-8.533,3.823-8.533,8.533V315.733z M204.8,273.067h17.067V307.2H204.8V273.067z"
}), React.createElement("path", {
  d: "M196.267,221.867H230.4c4.71,0,8.533-3.823,8.533-8.533v-51.2c0-4.71-3.823-8.533-8.533-8.533h-34.133 c-4.71,0-8.533,3.823-8.533,8.533v51.2C187.733,218.044,191.556,221.867,196.267,221.867z M204.8,170.667h17.067V204.8H204.8 V170.667z"
}), React.createElement("path", {
  d: "M132.395,160.913L256,86.75l123.605,74.163c1.374,0.828,2.893,1.22,4.386,1.22c2.901,0,5.726-1.476,7.322-4.139 c2.432-4.045,1.118-9.284-2.918-11.708L264.533,71.97V17.067H307.2v17.067h-25.6c-4.71,0-8.533,3.823-8.533,8.533 c0,4.71,3.823,8.533,8.533,8.533h34.133c4.71,0,8.533-3.823,8.533-8.533V8.533c0-4.71-3.823-8.533-8.533-8.533H256 c-4.71,0-8.533,3.823-8.533,8.533V71.97l-123.861,74.317c-4.036,2.423-5.35,7.663-2.918,11.708 C123.102,162.031,128.358,163.345,132.395,160.913z"
}), React.createElement("path", {
  d: "M93.867,324.267c4.71,0,8.533-3.823,8.533-8.533v-51.2c0-4.71-3.823-8.533-8.533-8.533H59.733 c-4.71,0-8.533,3.823-8.533,8.533V281.6c0,4.71,3.823,8.533,8.533,8.533s8.533-3.823,8.533-8.533v-8.533h17.067v42.667 C85.333,320.444,89.156,324.267,93.867,324.267z"
}), React.createElement("path", {
  d: "M153.6,435.2V187.733c0-4.71-3.823-8.533-8.533-8.533c-4.71,0-8.533,3.823-8.533,8.533V435.2 c0,4.71,3.823,8.533,8.533,8.533C149.777,443.733,153.6,439.91,153.6,435.2z"
}), React.createElement("path", {
  d: "M110.933,477.867h290.133c4.71,0,8.533-3.823,8.533-8.533s-3.823-8.533-8.533-8.533h-76.8v-85.333h8.533 c4.71,0,8.533-3.823,8.533-8.533s-3.823-8.533-8.533-8.533H179.2c-4.71,0-8.533,3.823-8.533,8.533s3.823,8.533,8.533,8.533h8.533 V460.8h-76.8c-4.71,0-8.533,3.823-8.533,8.533S106.223,477.867,110.933,477.867z M264.533,426.667 c4.71,0,8.533-3.823,8.533-8.533s-3.823-8.533-8.533-8.533v-34.133H307.2V460.8h-42.667V426.667z M204.8,375.467h42.667V409.6 c-4.71,0-8.533,3.823-8.533,8.533s3.823,8.533,8.533,8.533V460.8H204.8V375.467z"
}), React.createElement("path", {
  d: "M452.267,366.933h-34.133c-4.71,0-8.533,3.823-8.533,8.533v51.2c0,4.71,3.823,8.533,8.533,8.533h34.133 c4.71,0,8.533-3.823,8.533-8.533v-51.2C460.8,370.756,456.977,366.933,452.267,366.933z M443.733,418.133h-17.067V384h17.067 V418.133z"
}), React.createElement("path", {
  d: "M452.267,264.533h-34.133c-4.71,0-8.533,3.823-8.533,8.533v51.2c0,4.71,3.823,8.533,8.533,8.533h34.133 c4.71,0,8.533-3.823,8.533-8.533v-51.2C460.8,268.356,456.977,264.533,452.267,264.533z M443.733,315.733h-17.067V281.6h17.067 V315.733z"
}), React.createElement("path", {
  d: "M435.2,494.933H76.8c-4.71,0-8.533,3.823-8.533,8.533S72.09,512,76.8,512h358.4c4.71,0,8.533-3.823,8.533-8.533 S439.91,494.933,435.2,494.933z"
}), React.createElement("path", {
  d: "M503.467,187.733c-4.71,0-8.533,3.823-8.533,8.533v8.533h-93.867c-4.71,0-8.533,3.823-8.533,8.533 c0,4.71,3.823,8.533,8.533,8.533h93.867v281.6c0,4.71,3.823,8.533,8.533,8.533s8.533-3.823,8.533-8.533v-307.2 C512,191.556,508.177,187.733,503.467,187.733z"
}), React.createElement("path", {
  d: "M273.067,315.733c0,4.71,3.823,8.533,8.533,8.533h34.133c4.71,0,8.533-3.823,8.533-8.533v-51.2 c0-4.71-3.823-8.533-8.533-8.533H281.6c-4.71,0-8.533,3.823-8.533,8.533V315.733z M290.133,273.067H307.2V307.2h-17.067V273.067z "
}), React.createElement("path", {
  d: "M85.333,418.133c0-1.109-0.486-110.933-42.667-110.933C0.486,307.2,0,417.024,0,418.133 c0,20.608,14.686,37.837,34.133,41.805v43.529c0,4.71,3.823,8.533,8.533,8.533c4.71,0,8.533-3.823,8.533-8.533v-43.529 C70.647,455.97,85.333,438.741,85.333,418.133z M42.667,443.733c-14.114,0-25.6-11.486-25.6-25.6 c0-42.513,11.418-93.867,25.6-93.867c14.182,0,25.6,51.354,25.6,93.867C68.267,432.247,56.781,443.733,42.667,443.733z"
}), React.createElement("path", {
  d: "M375.467,435.2v-256c0-4.71-3.823-8.533-8.533-8.533s-8.533,3.823-8.533,8.533v256c0,4.71,3.823,8.533,8.533,8.533 S375.467,439.91,375.467,435.2z"
}), React.createElement("path", {
  d: "M281.6,221.867h34.133c4.71,0,8.533-3.823,8.533-8.533v-51.2c0-4.71-3.823-8.533-8.533-8.533H281.6 c-4.71,0-8.533,3.823-8.533,8.533v51.2C273.067,218.044,276.89,221.867,281.6,221.867z M290.133,170.667H307.2V204.8h-17.067 V170.667z"
}), React.createElement("path", {
  d: "M8.533,298.667c4.71,0,8.533-3.823,8.533-8.533v-68.267h93.867c4.71,0,8.533-3.823,8.533-8.533 c0-4.71-3.823-8.533-8.533-8.533H17.067v-8.533c0-4.71-3.823-8.533-8.533-8.533S0,191.556,0,196.267v93.867 C0,294.844,3.823,298.667,8.533,298.667z"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      "enableBackground": "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/university.573af481.svg";
export { SvgComponent as ReactComponent };